export default "__VITE_ASSET__efb50611__"